import { useTranslation } from '@frontend/i18n';
import { useFormField } from '@frontend/design-system';
import { useSoftphoneSettings } from '../../providers/softphone-settings-provider';
import { SettingItem } from './setting-item';

export const DnDToggle = () => {
  const { t } = useTranslation('softphone');
  const enableDoNotDisturb = useSoftphoneSettings((ctx) => ctx.enableDoNotDisturb);
  const disableDoNotDisturb = useSoftphoneSettings((ctx) => ctx.disableDoNotDisturb);
  const isDoNotDisturb = useSoftphoneSettings((ctx) => ctx.isDoNotDisturb);

  const switchProps = useFormField({
    type: 'switch',
    value: isDoNotDisturb,
  });

  const props = {
    ...switchProps,
    onChange: (e: any) => {
      switchProps.onChange(e);
      // @ts-ignore design system change event types are no bueno
      if (e?.value) enableDoNotDisturb?.();
      else disableDoNotDisturb?.();
    },
  };

  return (
    <SettingItem
      switchProps={props}
      title={t('Do Not Disturb (DND)')}
      helperText={t('Turning on Do Not Disturb (DND) will stop all inbound calls to your softphone.')}
    />
  );
};
